/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from 'react';
import {
  Card,
  Text,
  Button
} from '@fluentui/react-components';
import { strings } from '../../intl/Strings';
import M365FilesImage from './components/assets/M365_Files_light.png';
import DeviceMultipleImage from './components/assets/Device_Multiple_light.png';
import AILLMImage from './components/assets/AI_LLM_light.png';
import { logger } from '../../shared';
import { useStyles } from './TrialBenefitsDialog.styles';

export const TrialBenefitsDialog: React.FC = () => {
  const styles = useStyles();

  const seeMoreBenefits = async () => {
    logger.logInfo('TrialBenefitsDialogClick', 'User clicked See More Benefits button on Trial Benefits dialog');
    window.open("https://account.microsoft.com/?openEssentialsBenefits", "_blank");
  };

  return (
    <div className={styles.dialogContainer}>
      <div className={styles.header}>
        <div className={styles.titleText}>
          {strings.getString('trialBenefitsTitle')}
      </div>
      </div>
      <div className={styles.cardsWrapper}>
        <div className={styles.cards}>
          <Card className={styles.benefitCard}>
            <div className={styles.imageContainer}>
              <img
                src={M365FilesImage}
                alt="file-image"
                className={styles.cardImage}
              />
            </div>
            <div className={styles.cardTextContainer}>
              <Text className={styles.cardTitle}>
                {strings.getString('trialBenefitsFileSaveCardTitle')}
              </Text>
              <Text className={styles.cardDescription}>
                {strings.getString('trialBenefitsFileSaveCardDescription')}
              </Text>
            </div>
          </Card>
          <Card className={styles.benefitCard}>
            <div className={styles.imageContainer}>
              <img
                src={DeviceMultipleImage}
                alt="device-image"
                className={styles.cardImage}
              />
            </div>
            <div className={styles.cardTextContainer}>
              <Text className={styles.cardTitle}>
                {strings.getString('trialBenefitsAccessAnywhereCardTitle')}
              </Text>
              <Text className={styles.cardDescription}>
                {strings.getString('trialBenefitsAccessAnywhereCardDescription')}
              </Text>
            </div>
          </Card>
          <Card className={styles.benefitCard}>
            <div className={styles.imageContainer}>
              <img
                src={AILLMImage}
                alt="ai-image"
                className={styles.cardImage}
              />
            </div>
            <div className={styles.cardTextContainer}>
              <Text className={styles.cardTitle}>
                {strings.getString('trialBenefitsCopilotCardTitle')}
              </Text>
              <Text className={styles.cardDescription}>
                {strings.getString('trialBenefitsCopilotCardDescription')}
              </Text>
            </div>
          </Card>
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Button
          appearance="primary"
          onClick={seeMoreBenefits}
          className={styles.button}
        >
          {strings.getString('trialBenefitsSeeMoreButton')}
        </Button>
      </div>
    </div>
  );
};
